import type { CSSProperties, ElementType } from "react";
import { memo } from "react";
import { cn } from "../../lib/utils";

export type TextShimmerProps = {
	children: string;
	as?: ElementType;
	className?: string;
	duration?: number;
};

const ShimmerComponent = ({
	children,
	as: Component = "p",
	className,
	duration = 1,
}: TextShimmerProps) => {
	return (
		<Component
			className={cn("crowdex-shimmer", className)}
			style={
				{
					"--crowdex-shimmer-cycle": `${duration * 4}s`,
				} as CSSProperties
			}
		>
			{children}
		</Component>
	);
};

export const Shimmer = memo(ShimmerComponent);
